import Swal from 'sweetalert2';

// Configuración global de SweetAlert2 con soporte para temas
const SweetAlert = Swal.mixin({
  // Configuración base que se aplicará a todos los alerts
  customClass: {
    popup: 'swal2-themed-popup',
    title: 'swal2-themed-title',
    content: 'swal2-themed-content',
    confirmButton: 'swal2-themed-confirm',
    cancelButton: 'swal2-themed-cancel',
    input: 'swal2-themed-input'
  }
});

// Funciones helper para diferentes tipos de alertas
export const showSuccess = (title, text = '', options = {}) => {
  return SweetAlert.fire({
    icon: 'success',
    title,
    text,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#21ba45',
    ...options
  });
};

export const showError = (title, text = '', options = {}) => {
  return SweetAlert.fire({
    icon: 'error',
    title,
    text,
    confirmButtonText: 'Intentar de nuevo',
    confirmButtonColor: '#db2828',
    ...options
  });
};

export const showWarning = (title, text = '', options = {}) => {
  return SweetAlert.fire({
    icon: 'warning',
    title,
    text,
    confirmButtonText: 'Entendido',
    confirmButtonColor: '#fbbd08',
    ...options
  });
};

export const showInfo = (title, text = '', options = {}) => {
  return SweetAlert.fire({
    icon: 'info',
    title,
    text,
    confirmButtonText: 'Continuar',
    confirmButtonColor: '#2185d0',
    ...options
  });
};

export const showConfirm = (title, text = '', options = {}) => {
  return SweetAlert.fire({
    icon: 'question',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: 'Sí, continuar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#21ba45',
    cancelButtonColor: '#db2828',
    reverseButtons: true,
    ...options
  });
};

export const showInput = (title, inputPlaceholder = '', options = {}) => {
  return SweetAlert.fire({
    title,
    input: 'text',
    inputPlaceholder,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#2185d0',
    cancelButtonColor: '#db2828',
    inputValidator: (value) => {
      if (!value) {
        return 'Este campo es obligatorio';
      }
    },
    ...options
  });
};

export const showLoading = (title = 'Cargando...', options = {}) => {
  return SweetAlert.fire({
    title,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
    ...options
  });
};

// Exportar el objeto SweetAlert configurado como default
export default SweetAlert;
